export default [
    {
        label: "Documents",
        icon: "icon-folder",
        tableSettings: {
            route: "adjustdocuments",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
            },
            filterEndpoint: "myAdjustdocuments", 
            showAddBtnDefault: true,
            showActionButtonDefault: true, //if this is false the add and edit button will not be shown 
            showEditBtnDefault: true, 
            //change the default above, the one below will be overwriten during run time
            showAddBtn: false,
            showActionButton: false,  
            showEditBtn: false, 
            
        },
    },
     
]